import dayjs from "dayjs";
import {getRelevantStore} from "../../../helpers/functions";
import {t} from 'i18next';
import {DB_DATE_FORMAT, DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import {store} from "@arboxappv4/shared/src/redux/store";
import {INSERT_SCHEDULE_USER} from "@arboxappv4/shared/src/constants/booking";

export const getRequestDateLabel = (values) => {
    const relevantStore = getRelevantStore(true)
    const globalLocation = relevantStore.selectedLocation
    const language = relevantStore.language;
    let dates = ''
    if(values.from && values.to) {
        if(values.from !== values.to) {
            const dateFrom = dayjs(values.from).format(globalLocation.date_format)
            const dateTo = dayjs(values.to).format(globalLocation.date_format)
            dates = `${dateFrom} - ${dateTo}`
        } else {
            dates = dayjs(values.from).locale(language?.code ?? 'en').format(`dddd, ${globalLocation.date_format}`)
        }
    }
    return dates
}

export const getRequestTimeRangeLabel = (values, showAllRange) => {
    let times = t('any-time')
    if(values.timeRange?.length) {
        if(showAllRange) {
            times = values.timeRange.map(range => getSingleRangeText(range)).join(', ')
        } else {
            times = getSingleRangeText(values.timeRange[0])
        }
    }
    return times
}

const getSingleRangeText = (rangeObj) => {
    const relevantStore = getRelevantStore(true)
    const globalLocation = relevantStore.selectedLocation
    const timeFrom = dayjs(rangeObj.from, DB_TIME_FORMAT).format(globalLocation.time_format)
    const timeTo = dayjs(rangeObj.to, DB_TIME_FORMAT).format(globalLocation.time_format)
    return `${timeFrom} - ${timeTo}`
}


export const getWaitlistOfferLabels = (offer) => {
    if (!offer) return {serviceName: '', coach: null, dateLabel: '', timeLabel: ''};
    const relevantStore = getRelevantStore(true)
    const location = relevantStore.selectedLocation;
    const language = relevantStore.language;
    const timeFormat = location?.time_format ?? 'HH:mm';
    const dateLabel = offer.date ? dayjs(offer.date, DB_DATE_FORMAT).locale(language?.code ?? 'en').format(`dddd, ${location?.date_format}`) : '';
    let timeLabel = '';
    if (offer.start_time) {
        const start = dayjs(offer.start_time, DB_TIME_FORMAT).format(timeFormat);
        const end = offer.end_time ? dayjs(offer.end_time, DB_TIME_FORMAT).format(timeFormat) : null;
        timeLabel = end ? `${start} - ${end}` : start;
    }
    return {serviceName: offer.box_category?.name ?? '', coach: offer.coach ?? null, dateLabel, timeLabel};
};

export const translateSlotOfferToScheduleObj = () => {
    const relevantStore = getRelevantStore(true)
    const appointmentWaitlistOffer = relevantStore?.appointmentWaitlistOffer
    if(appointmentWaitlistOffer) {
        return {
            ...appointmentWaitlistOffer,
            availability: true,
            is_open: true,
            booking_option: INSERT_SCHEDULE_USER,
            id: appointmentWaitlistOffer.availability_id,
            locations_box_fk: appointmentWaitlistOffer.locations_box_id,
            time: appointmentWaitlistOffer.start_time,
            box_categories: appointmentWaitlistOffer.box_category,
            break_length: appointmentWaitlistOffer.availability.break_length
        }
    }
    return null
}


export const appointmentWaitlistRejections = {
    CONFIRM_WINDOW_EXPIRED: 'CONFIRM_WINDOW_EXPIRED',
    WAITLIST_DISABLED: 'WAITLIST_DISABLED',
    REMOVED_BY_BUSINESS: 'REMOVED_BY_BUSINESS',
    REMOVED_BY_USER: 'REMOVED_BY_USER',
    ALREADY_CONFIRMED: 'ALREADY_CONFIRMED',
    SLOT_TIME_PASSED: 'SLOT_TIME_PASSED',
    SKIPPED_SLOT: 'SKIPPED_SLOT',
}

export const WAITLIST_DONT_WANT_ACTIONS = {
    SKIP: 'skip',
    REMOVE: 'remove',
}